import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { View, Text } from 'react-native-web';

import proNotifications from '../../../modules/proNotifications';

import StateLink from '../../StateLink';

import './ScheduleGapFill.module.scss';

/**
 * Schedule gap fill notification
 */
export default function ScheduleGapFill(props) {
  const { notification } = props;
  const localStart = moment(notification.local_start);
  const trackingParams = {
    notification_key: notification.uuid,
    appointment_id: notification.appointment_id,
    client_id: notification.client_id,
    schedule_gap_id: notification.schedule_gap_id,
    service_id: notification.service_id,
    service_name: notification.service_name,
    service_cost: notification.total_appt_cost,
    type: notification.type,
  };

  return (
    <StateLink
      to="provider.appointment"
      params={{ viewApptId: notification.object_id }}
      clickTracking={{
        name: proNotifications.NOTIFICATION_CLICKED_EVENT,
        params: trackingParams,
      }}
    >
      <View styleName="notification" data-test-id="scheduleGapNotification">
        <View styleName="icon">
          <View styleName="sparkles" />
        </View>
        <View styleName="notificationBody">
          <Text styleName="notificationText">
            <Text styleName="strong">
              We filled your last minute cancellation
            </Text>
            <Text>
              &nbsp;for {localStart.format('dddd, MMM D')}
              &nbsp;at {localStart.format('h:mm A')}
            </Text>
          </Text>
          <Text styleName="fromNow">
            {proNotifications.getFromNowDisplay(notification.creation_time)}
          </Text>
          <View styleName="notificationSubtext">
            <View styleName="notificationSubtextDivider" />
            <Text styleName="notificationSubtextContent">
              Your client got the time they wanted and you don&apos;t have to miss out on earnings!
            </Text>
          </View>
        </View>
      </View>
    </StateLink>
  );
}

ScheduleGapFill.propTypes = {
  /** The notification object */
  notification: PropTypes.object.isRequired,
};
